import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-natureza-juridica-form-control',
    templateUrl: './natureza-juridica-form-control.component.html',
    styleUrls: ['./natureza-juridica-form-control.component.less']
})
export class NaturezaJuridicaFormControlComponent {
    @Input() label = 'Natureza Jurídica';
    @Input() helpText = 'Código e descrição da Natureza Jurídica da empresa';
    @Input() codigo: number = null;
    @Input() nome: string = null;
}
